export default __webpack_public_path__ + "static/media/Tom Kuhn.1645486d.jpg";